import React from 'react';
import PropTypes from 'prop-types';
import EmptyIcon from '../../assets/empty.svg';
import LoadingMessage from '../LoadingMessage';

import style from './EmptyTableMessage.module.scss';

const EmptyTableMessage = ({
  message, children, loading, loadingMessage,
}) => (
  <>
    {loading
      ? <LoadingMessage message={loadingMessage} />
      : (
        <div className={style.emptyTableContainer}>
          <img src={EmptyIcon} alt="" />
          {message}
          {children}
        </div>
      )
    }
  </>
);

export default EmptyTableMessage;

EmptyTableMessage.propTypes = {
  loading: PropTypes.bool,
  loadingMessage: PropTypes.string,
  message: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

EmptyTableMessage.defaultProps = {
  loading: false,
  loadingMessage: undefined,
  children: undefined,
};
